export var ChatPanelTab;
(function(ChatPanelTab) {
    ChatPanelTab["GENERAL"] = "general";
    ChatPanelTab["REQUESTS"] = "requests";
})(ChatPanelTab || (ChatPanelTab = {}));

//# sourceMappingURL=types.js.map